import { Color as U } from "./index.es440.js";
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
const et = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function P(e) {
  return e == null;
}
function m(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function f(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function ne(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function tt(e, t) {
  return ne(e) ? e : t;
}
function h(e, t) {
  return typeof e > "u" ? t : e;
}
const nt = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, re = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function rt(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function it(e, t, n, r) {
  let i, o, s;
  if (m(e))
    for (o = e.length, i = 0; i < o; i++)
      t.call(n, e[i], i);
  else if (f(e))
    for (s = Object.keys(e), o = s.length, i = 0; i < o; i++)
      t.call(n, e[s[i]], s[i]);
}
function ot(e, t) {
  let n, r, i, o;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, r = e.length; n < r; ++n)
    if (i = e[n], o = t[n], i.datasetIndex !== o.datasetIndex || i.index !== o.index)
      return !1;
  return !0;
}
function C(e) {
  if (m(e))
    return e.map(C);
  if (f(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), r = n.length;
    let i = 0;
    for (; i < r; ++i)
      t[n[i]] = C(e[n[i]]);
    return t;
  }
  return e;
}
function Y(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function ie(e, t, n, r) {
  if (!Y(e))
    return;
  const i = t[e], o = n[e];
  f(i) && f(o) ? I(i, o, r) : t[e] = C(o);
}
function I(e, t, n) {
  const r = m(t) ? t : [
    t
  ], i = r.length;
  if (!f(e))
    return e;
  n = n || {};
  const o = n.merger || ie;
  let s;
  for (let a = 0; a < i; ++a) {
    if (s = r[a], !f(s))
      continue;
    const c = Object.keys(s);
    for (let l = 0, u = c.length; l < u; ++l)
      o(c[l], e, s, n);
  }
  return e;
}
function oe(e, t) {
  return I(e, t, {
    merger: se
  });
}
function se(e, t, n) {
  if (!Y(e))
    return;
  const r = t[e], i = n[e];
  f(r) && f(i) ? oe(r, i) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = C(i));
}
const H = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function ae(e) {
  const t = e.split("."), n = [];
  let r = "";
  for (const i of t)
    r += i, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function ce(e) {
  const t = ae(e);
  return (n) => {
    for (const r of t) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function le(e, t) {
  return (H[t] || (H[t] = ce(t)))(e);
}
function $(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const st = (e) => typeof e < "u", M = (e) => typeof e == "function", at = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function ct(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const y = Math.PI, b = 2 * y, j = Number.POSITIVE_INFINITY, N = y / 2, lt = Math.sign;
function ut(e) {
  const t = [], n = Math.sqrt(e);
  let r;
  for (r = 1; r < n; r++)
    e % r === 0 && (t.push(r), t.push(e / r));
  return n === (n | 0) && t.push(n), t.sort((i, o) => i - o).pop(), t;
}
function ue(e) {
  return typeof e == "symbol" || typeof e == "object" && e !== null && !(Symbol.toPrimitive in e || "toString" in e || "valueOf" in e);
}
function ft(e) {
  return !ue(e) && !isNaN(parseFloat(e)) && isFinite(e);
}
function dt(e) {
  return e * (y / 180);
}
function ht(e) {
  return e * (180 / y);
}
function gt(e, t) {
  const n = t.x - e.x, r = t.y - e.y, i = Math.sqrt(n * n + r * r);
  let o = Math.atan2(r, n);
  return o < -0.5 * y && (o += b), {
    angle: o,
    distance: i
  };
}
function d(e) {
  return (e % b + b) % b;
}
function mt(e, t, n, r) {
  const i = d(e), o = d(t), s = d(n), a = d(o - i), c = d(s - i), l = d(i - o), u = d(i - s);
  return i === o || i === s || r && o === s || a > c && l < u;
}
function fe(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function bt(e) {
  return fe(e, -32768, 32767);
}
function yt(e, t, n, r = 1e-6) {
  return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
}
function G(e, t, n) {
  n = n || ((s) => e[s] < t);
  let r = e.length - 1, i = 0, o;
  for (; r - i > 1; )
    o = i + r >> 1, n(o) ? i = o : r = o;
  return {
    lo: i,
    hi: r
  };
}
const pt = (e, t, n, r) => G(e, n, r ? (i) => {
  const o = e[i][t];
  return o < n || o === n && e[i + 1][t] === n;
} : (i) => e[i][t] < n), _t = (e, t, n) => G(e, n, (r) => e[r][t] >= n);
function wt(e, t, n) {
  let r = 0, i = e.length;
  for (; r < i && e[r] < t; )
    r++;
  for (; i > r && e[i - 1] > n; )
    i--;
  return r > 0 || i < e.length ? e.slice(r, i) : e;
}
const V = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function xt(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), V.forEach((n) => {
    const r = "_onData" + $(n), i = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...o) {
        const s = i.apply(this, o);
        return e._chartjs.listeners.forEach((a) => {
          typeof a[r] == "function" && a[r](...o);
        }), s;
      }
    });
  });
}
function Ot(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const r = n.listeners, i = r.indexOf(t);
  i !== -1 && r.splice(i, 1), !(r.length > 0) && (V.forEach((o) => {
    delete e[o];
  }), delete e._chartjs);
}
function St(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const de = (function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
})();
function kt(e, t) {
  let n = [], r = !1;
  return function(...i) {
    n = i, r || (r = !0, de.call(window, () => {
      r = !1, e.apply(t, n);
    }));
  };
}
function Pt(e, t) {
  let n;
  return function(...r) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, r)) : e.apply(this, r), t;
  };
}
const Ct = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", It = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, O = (e) => e === 0 || e === 1, z = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * b / n)), K = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * b / n) + 1, T = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * N) + 1,
  easeOutSine: (e) => Math.sin(e * N),
  easeInOutSine: (e) => -0.5 * (Math.cos(y * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => O(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => O(e) ? e : z(e, 0.075, 0.3),
  easeOutElastic: (e) => O(e) ? e : K(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return O(e) ? e : e < 0.5 ? 0.5 * z(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * K(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - T.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? T.easeInBounce(e * 2) * 0.5 : T.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function X(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function Mt(e) {
  return X(e) ? e : new U(e);
}
function v(e) {
  return X(e) ? e : new U(e).saturate(0.5).darken(0.1).hexString();
}
const he = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], ge = [
  "color",
  "borderColor",
  "backgroundColor"
];
function me(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: ge
    },
    numbers: {
      type: "number",
      properties: he
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function be(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const L = /* @__PURE__ */ new Map();
function ye(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let r = L.get(n);
  return r || (r = new Intl.NumberFormat(e, t), L.set(n, r)), r;
}
function jt(e, t, n) {
  return ye(t, n).format(e);
}
const pe = {
  values(e) {
    return m(e) ? e : "" + e;
  }
};
var _e = {
  formatters: pe
};
function we(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: _e.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const xe = /* @__PURE__ */ Object.create(null), Oe = /* @__PURE__ */ Object.create(null);
function _(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let r = 0, i = n.length; r < i; ++r) {
    const o = n[r];
    e = e[o] || (e[o] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function W(e, t, n) {
  return typeof t == "string" ? I(_(e, t), n) : I(_(e, ""), t);
}
class Se {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, i) => v(i.backgroundColor), this.hoverBorderColor = (r, i) => v(i.borderColor), this.hoverColor = (r, i) => v(i.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return W(this, t, n);
  }
  get(t) {
    return _(this, t);
  }
  describe(t, n) {
    return W(Oe, t, n);
  }
  override(t, n) {
    return W(xe, t, n);
  }
  route(t, n, r, i) {
    const o = _(this, t), s = _(this, r), a = "_" + n;
    Object.defineProperties(o, {
      [a]: {
        value: o[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const c = this[a], l = s[i];
          return f(c) ? Object.assign({}, l, c) : h(c, l);
        },
        set(c) {
          this[a] = c;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var ke = /* @__PURE__ */ new Se({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  me,
  be,
  we
]);
function Pe(e) {
  return !e || P(e.size) || P(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function At(e, t, n, r, i) {
  let o = t[i];
  return o || (o = t[i] = e.measureText(i).width, n.push(i)), o > r && (r = o), r;
}
function Rt(e, t, n) {
  const r = e.currentDevicePixelRatio, i = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - i) * r) / r + i;
}
function Bt(e, t) {
  !t && !e || (t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
function Tt(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function vt(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function Wt(e) {
  e.restore();
}
function Ce(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), P(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function Ie(e, t, n, r, i) {
  if (i.strikethrough || i.underline) {
    const o = e.measureText(r), s = t - o.actualBoundingBoxLeft, a = t + o.actualBoundingBoxRight, c = n - o.actualBoundingBoxAscent, l = n + o.actualBoundingBoxDescent, u = i.strikethrough ? (c + l) / 2 : l;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = i.decorationWidth || 2, e.moveTo(s, u), e.lineTo(a, u), e.stroke();
  }
}
function Me(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function Et(e, t, n, r, i, o = {}) {
  const s = m(t) ? t : [
    t
  ], a = o.strokeWidth > 0 && o.strokeColor !== "";
  let c, l;
  for (e.save(), e.font = i.string, Ce(e, o), c = 0; c < s.length; ++c)
    l = s[c], o.backdrop && Me(e, o.backdrop), a && (o.strokeColor && (e.strokeStyle = o.strokeColor), P(o.strokeWidth) || (e.lineWidth = o.strokeWidth), e.strokeText(l, n, r, o.maxWidth)), e.fillText(l, n, r, o.maxWidth), Ie(e, n, r, l, o), r += Number(i.lineHeight);
  e.restore();
}
const je = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, Ae = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function Re(e, t) {
  const n = ("" + e).match(je);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const Be = (e) => +e || 0;
function Te(e, t) {
  const n = {}, r = f(t), i = r ? Object.keys(t) : t, o = f(e) ? r ? (s) => h(e[s], e[t[s]]) : (s) => e[s] : () => e;
  for (const s of i)
    n[s] = Be(o(s));
  return n;
}
function ve(e) {
  return Te(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Dt(e) {
  const t = ve(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function Ft(e, t) {
  e = e || {}, t = t || ke.font;
  let n = h(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = h(e.style, t.style);
  r && !("" + r).match(Ae) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const i = {
    family: h(e.family, t.family),
    lineHeight: Re(h(e.lineHeight, t.lineHeight), n),
    size: n,
    style: r,
    weight: h(e.weight, t.weight),
    string: ""
  };
  return i.string = Pe(i), i;
}
function Ht(e, t, n, r) {
  let i, o, s;
  for (i = 0, o = e.length; i < o; ++i)
    if (s = e[i], s !== void 0 && s !== void 0)
      return s;
}
function Nt(e, t, n) {
  const { min: r, max: i } = e, o = re(t, (i - r) / 2), s = (a, c) => n && a === 0 ? 0 : a + c;
  return {
    min: s(r, -Math.abs(o)),
    max: s(i, o)
  };
}
function zt(e, t) {
  return Object.assign(Object.create(e), t);
}
function Z(e, t = [
  ""
], n, r, i = () => e[0]) {
  const o = n || e;
  typeof r > "u" && (r = te("_fallback", e));
  const s = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: o,
    _fallback: r,
    _getTarget: i,
    override: (a) => Z([
      a,
      ...e
    ], t, o, r)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, c) {
      return delete a[c], delete a._keys, delete e[0][c], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, c) {
      return J(a, c, () => Le(c, t, e, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, c) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], c);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, c) {
      return Q(a).includes(c);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return Q(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, c, l) {
      const u = a._storage || (a._storage = i());
      return a[c] = u[c] = l, delete a._keys, !0;
    }
  });
}
function A(e, t, n, r) {
  const i = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: We(e, r),
    setContext: (o) => A(e, o, n, r),
    override: (o) => A(e.override(o), t, n, r)
  };
  return new Proxy(i, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, s) {
      return delete o[s], delete e[s], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, s, a) {
      return J(o, s, () => De(o, s, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, s) {
      return o._descriptors.allKeys ? Reflect.has(e, s) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, s);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(o, s) {
      return Reflect.has(e, s);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(o, s, a) {
      return e[s] = a, delete o[s], !0;
    }
  });
}
function We(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: r = t.indexable, _allKeys: i = t.allKeys } = e;
  return {
    allKeys: i,
    scriptable: n,
    indexable: r,
    isScriptable: M(n) ? n : () => n,
    isIndexable: M(r) ? r : () => r
  };
}
const Ee = (e, t) => e ? e + $(t) : t, E = (e, t) => f(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function J(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor")
    return e[t];
  const r = n();
  return e[t] = r, r;
}
function De(e, t, n) {
  const { _proxy: r, _context: i, _subProxy: o, _descriptors: s } = e;
  let a = r[t];
  return M(a) && s.isScriptable(t) && (a = Fe(t, a, e, n)), m(a) && a.length && (a = He(t, a, e, s.isIndexable)), E(t, a) && (a = A(a, i, o && o[t], s)), a;
}
function Fe(e, t, n, r) {
  const { _proxy: i, _context: o, _subProxy: s, _stack: a } = n;
  if (a.has(e))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + e);
  a.add(e);
  let c = t(o, s || r);
  return a.delete(e), E(e, c) && (c = D(i._scopes, i, e, c)), c;
}
function He(e, t, n, r) {
  const { _proxy: i, _context: o, _subProxy: s, _descriptors: a } = n;
  if (typeof o.index < "u" && r(e))
    return t[o.index % t.length];
  if (f(t[0])) {
    const c = t, l = i._scopes.filter((u) => u !== c);
    t = [];
    for (const u of c) {
      const w = D(l, i, e, u);
      t.push(A(w, o, s && s[e], a));
    }
  }
  return t;
}
function ee(e, t, n) {
  return M(e) ? e(t, n) : e;
}
const Ne = (e, t) => e === !0 ? t : typeof e == "string" ? le(t, e) : void 0;
function ze(e, t, n, r, i) {
  for (const o of t) {
    const s = Ne(n, o);
    if (s) {
      e.add(s);
      const a = ee(s._fallback, n, i);
      if (typeof a < "u" && a !== n && a !== r)
        return a;
    } else if (s === !1 && typeof r < "u" && n !== r)
      return null;
  }
  return !1;
}
function D(e, t, n, r) {
  const i = t._rootScopes, o = ee(t._fallback, n, r), s = [
    ...e,
    ...i
  ], a = /* @__PURE__ */ new Set();
  a.add(r);
  let c = q(a, s, n, o || n, r);
  return c === null || typeof o < "u" && o !== n && (c = q(a, s, o, c, r), c === null) ? !1 : Z(Array.from(a), [
    ""
  ], i, o, () => Ke(t, n, r));
}
function q(e, t, n, r, i) {
  for (; n; )
    n = ze(e, t, n, r, i);
  return n;
}
function Ke(e, t, n) {
  const r = e._getTarget();
  t in r || (r[t] = {});
  const i = r[t];
  return m(i) && f(n) ? n : i || {};
}
function Le(e, t, n, r) {
  let i;
  for (const o of t)
    if (i = te(Ee(o, e), n), typeof i < "u")
      return E(e, i) ? D(n, r, e, i) : i;
}
function te(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const r = n[e];
    if (typeof r < "u")
      return r;
  }
}
function Q(e) {
  let t = e._keys;
  return t || (t = e._keys = qe(e._scopes)), t;
}
function qe(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of Object.keys(n).filter((i) => !i.startsWith("_")))
      t.add(r);
  return Array.from(t);
}
function Qe() {
  return typeof window < "u" && typeof document < "u";
}
function Ue(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function R(e, t, n) {
  let r;
  return typeof e == "string" ? (r = parseInt(e, 10), e.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[n])) : r = e, r;
}
const B = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function Ye(e, t) {
  return B(e).getPropertyValue(t);
}
const $e = [
  "top",
  "right",
  "bottom",
  "left"
];
function g(e, t, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let i = 0; i < 4; i++) {
    const o = $e[i];
    r[o] = parseFloat(e[t + "-" + o + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const Ge = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function Ve(e, t) {
  const n = e.touches, r = n && n.length ? n[0] : e, { offsetX: i, offsetY: o } = r;
  let s = !1, a, c;
  if (Ge(i, o, e.target))
    a = i, c = o;
  else {
    const l = t.getBoundingClientRect();
    a = r.clientX - l.left, c = r.clientY - l.top, s = !0;
  }
  return {
    x: a,
    y: c,
    box: s
  };
}
function Kt(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: r } = t, i = B(n), o = i.boxSizing === "border-box", s = g(i, "padding"), a = g(i, "border", "width"), { x: c, y: l, box: u } = Ve(e, n), w = s.left + (u && a.left), x = s.top + (u && a.top);
  let { width: p, height: F } = t;
  return o && (p -= s.width + a.width, F -= s.height + a.height), {
    x: Math.round((c - w) / p * n.width / r),
    y: Math.round((l - x) / F * n.height / r)
  };
}
function Xe(e, t, n) {
  let r, i;
  if (t === void 0 || n === void 0) {
    const o = e && Ue(e);
    if (!o)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const s = o.getBoundingClientRect(), a = B(o), c = g(a, "border", "width"), l = g(a, "padding");
      t = s.width - l.width - c.width, n = s.height - l.height - c.height, r = R(a.maxWidth, o, "clientWidth"), i = R(a.maxHeight, o, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: r || j,
    maxHeight: i || j
  };
}
const S = (e) => Math.round(e * 10) / 10;
function Lt(e, t, n, r) {
  const i = B(e), o = g(i, "margin"), s = R(i.maxWidth, e, "clientWidth") || j, a = R(i.maxHeight, e, "clientHeight") || j, c = Xe(e, t, n);
  let { width: l, height: u } = c;
  if (i.boxSizing === "content-box") {
    const x = g(i, "border", "width"), p = g(i, "padding");
    l -= p.width + x.width, u -= p.height + x.height;
  }
  return l = Math.max(0, l - o.width), u = Math.max(0, r ? l / r : u - o.height), l = S(Math.min(l, s, c.maxWidth)), u = S(Math.min(u, a, c.maxHeight)), l && !u && (u = S(l / 2)), (t !== void 0 || n !== void 0) && r && c.height && u > c.height && (u = c.height, l = S(Math.floor(u * r))), {
    width: l,
    height: u
  };
}
function qt(e, t, n) {
  const r = t || 1, i = Math.floor(e.height * r), o = Math.floor(e.width * r);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const s = e.canvas;
  return s.style && (n || !s.style.height && !s.style.width) && (s.style.height = `${e.height}px`, s.style.width = `${e.width}px`), e.currentDevicePixelRatio !== r || s.height !== i || s.width !== o ? (e.currentDevicePixelRatio = r, s.height = i, s.width = o, e.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const Qt = (function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    Qe() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
})();
function Ut(e, t) {
  const n = Ye(e, t), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function k(e, t, n) {
  return e.options.clip ? e[n] : t[n];
}
function Ze(e, t) {
  const { xScale: n, yScale: r } = e;
  return n && r ? {
    left: k(n, t, "left"),
    right: k(n, t, "right"),
    top: k(r, t, "top"),
    bottom: k(r, t, "bottom")
  } : t;
}
function Yt(e, t) {
  const n = t._clip;
  if (n.disabled)
    return !1;
  const r = Ze(t, e.chartArea);
  return {
    left: n.left === !1 ? 0 : r.left - (n.left === !0 ? 0 : n.left),
    right: n.right === !1 ? e.width : r.right + (n.right === !0 ? 0 : n.right),
    top: n.top === !1 ? 0 : r.top - (n.top === !0 ? 0 : n.top),
    bottom: n.bottom === !1 ? e.height : r.bottom + (n.bottom === !0 ? 0 : n.bottom)
  };
}
export {
  Wt as $,
  _t as A,
  pt as B,
  Tt as C,
  gt as D,
  Dt as E,
  it as F,
  Lt as G,
  N as H,
  Ue as I,
  Ut as J,
  Qt as K,
  kt as L,
  Qe as M,
  ut as N,
  tt as O,
  y as P,
  rt as Q,
  Nt as R,
  fe as S,
  b as T,
  ht as U,
  At as V,
  bt as W,
  Rt as X,
  vt as Y,
  Et as Z,
  St as _,
  Ht as a,
  Ye as a$,
  Ft as a0,
  Ct as a1,
  It as a2,
  xe as a3,
  I as a4,
  $ as a5,
  Oe as a6,
  M as a7,
  A as a8,
  Z as a9,
  _e as aM,
  wt as aP,
  G as aQ,
  X as aR,
  v as aS,
  C as aT,
  ie as aU,
  se as aV,
  ae as aX,
  Pe as aY,
  We as aa,
  oe as ab,
  et as ac,
  Pt as ad,
  qt as ae,
  Bt as af,
  at as ag,
  Yt as ah,
  ot as ai,
  ct as aj,
  yt as ak,
  d as al,
  Te as am,
  ve as ax,
  m as b,
  Re as b1,
  j as b3,
  Mt as c,
  ke as d,
  T as e,
  le as f,
  ne as g,
  st as h,
  f as i,
  zt as j,
  P as k,
  xt as l,
  nt as m,
  re as n,
  jt as o,
  mt as p,
  de as r,
  lt as s,
  dt as t,
  Ot as u,
  h as v,
  ft as x,
  Kt as z
};
//# sourceMappingURL=index.es372.js.map
